import * as React from 'react';
import { UIHeading3, Button, UIText2 } from '@cian/ui-kit';

import { IconProductSalesStart16 } from '@cian/ui-kit-design-tokens/icons';

import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { HouseStats } from '../HouseStats';

import * as styles from './styles.css';
import { Label } from '../HouseLabels';

interface IHouseTooltipProps {
  name: string;
  houseInfo: string[];
  houseId: number;
  stats?: IHouseStats | null;
  isEscrow: boolean;
  isSalesStart?: boolean;
  onLinkClick(houseId: number, rooms?: string): void;
  onEscrowLabelClick(event: React.MouseEvent<HTMLElement>): void;
  isFloorPlanEnabled: boolean;
  onFloorPlanClick(): void;
}

export function HouseTooltip({
  name,
  houseInfo,
  houseId,
  stats,
  isEscrow,
  isSalesStart,
  onLinkClick,
  onEscrowLabelClick,
  isFloorPlanEnabled,
  onFloorPlanClick,
}: IHouseTooltipProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading3>{name}</UIHeading3>
        {isSalesStart && (
          <div className={styles['sales-start']}>
            <IconProductSalesStart16 color="icon-negative-default" viewBox="-1 -1 18 18" />
          </div>
        )}
      </div>

      <div className={styles['house-info']}>
        {houseInfo.map((item, i) => (
          <UIText2 key={item} color="gray60_100" whiteSpace="nowrap" display="inline">
            {item}
            {i < houseInfo.length - 1 ? ' • ' : ''}
          </UIText2>
        ))}
      </div>
      <div className={styles['labels']}>{isEscrow && <Label onClick={onEscrowLabelClick}>Эскроу</Label>}</div>
      {stats && <HouseStats {...stats} houseId={houseId} onLinkClick={onLinkClick} />}
      {!stats && (
        <div className={styles['line']}>
          <UIText2>Нет квартир в продаже</UIText2>
        </div>
      )}
      {stats && isFloorPlanEnabled && (
        <div className={styles['floor-plan-button']}>
          <Button theme="fill_secondary" size="XS" fullWidth onClick={onFloorPlanClick}>
            Квартиры на этажах
          </Button>
        </div>
      )}
    </div>
  );
}
